<div class="field-editor" [class.field-editor--fixed-panels]="fixedToolsLayout">
  @if (fixedToolsLayout) {
    <aside class="field-editor__left field-editor__left--thumbnails field-editor__left--review-desktop">
      <div class="field-editor__thumbnails-card">
        <div class="field-editor__thumbnails-head">
          <mat-icon>view_carousel</mat-icon>
          <div>
            <h3>{{ 'fieldEditorDocumentTitle' | translate }}</h3>
            <p>{{ displayDocumentName }} ({{ totalPages.length || 0 }} pages)</p>
          </div>
        </div>
        <div class="field-editor__thumbnails-list" #thumbnailsList>
          @for (page of totalPages; track page) {
            <button
              type="button"
              class="field-editor__thumbnail-item"
              [class.field-editor__thumbnail-item--active]="currentPageIndex === page"
              [attr.data-thumbnail-page]="page"
              (click)="scrollToPage(page)">
              <span class="field-editor__thumbnail-num">{{ page }}</span>
              <span class="field-editor__thumbnail-frame">
                @if (pageThumbnails[page - 1]) {
                  <img [src]="pageThumbnails[page - 1]" alt="" />
                } @else {
                  <span class="field-editor__thumbnail-placeholder"></span>
                }
              </span>
            </button>
          }
        </div>
      </div>
    </aside>

    <aside class="field-editor__left field-editor__left--review-mobile">
      <div class="field-editor__field-actions">
        <button mat-stroked-button type="button" class="field-editor__field-back" (click)="onFieldStepBack()">
          Back
        </button>
        <button mat-flat-button type="button" color="warn" class="field-editor__field-submit" (click)="onFieldStepSubmit()">
          Submit
        </button>
      </div>

      <div class="field-editor__tools-stack">
        <div class="field-editor__tools-card">
          <div class="field-editor__tools-inner">
            <div class="field-editor__panel-hint field-editor__hint">
              <div class="field-editor__panel-hint-brand">
                <div class="circle-hint"><img src="assets/hint.png" class="hint-icon" alt="Hint"></div>
                <span class="field-editor__panel-hint-title">Tools</span>
              </div>
              <p>Choose a tool and click or drag onto the document.</p>
            </div>
            <div class="field-editor__tools-grid">
              @for (tool of fieldTools; track tool.id) {
                <div
                  role="button"
                  tabindex="0"
                  class="field-editor__tool"
                  [class.field-editor__tool--active]="pdfEditState.selectedTool() === tool.id"
                  [class.field-editor__tool--dragging]="draggingToolId === tool.id"
                  [class.field-editor__tool--disabled]="isToolDisabled(tool)"
                  [attr.aria-disabled]="isToolDisabled(tool)"
                  [attr.draggable]="!isToolDisabled(tool)"
                  (click)="onToolClick(tool.id, $event)"
                  (keydown.enter)="onToolClick(tool.id, $event)"
                  (keydown.space)="onToolClick(tool.id, $event); $event.preventDefault()"
                  (dragstart)="onToolDragStart($event, tool.id)"
                  (dragend)="onToolDragEnd()">
                  <mat-icon>{{ tool.icon }}</mat-icon>
                  <span>{{ tool.label }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </aside>
  } @else if (!pdfEditState.showToolsInHeader()) {
    <aside class="field-editor__left">
      <div class="field-editor__tools-stack">
        <div class="field-editor__tools-card">
          <div class="field-editor__tools-inner">
            <div class="field-editor__panel-hint field-editor__hint">
              <div class="field-editor__panel-hint-brand">
                <div class="circle-hint"><img src="assets/hint.png" class="hint-icon" alt="Hint"></div>
                <span class="field-editor__panel-hint-title">Tools</span>
              </div>
              <p>Choose a tool and click or drag onto the document.</p>
            </div>
            <div class="field-editor__tools-grid">
              @for (tool of fieldTools; track tool.id) {
                <div
                  role="button"
                  tabindex="0"
                  class="field-editor__tool"
                  [class.field-editor__tool--active]="pdfEditState.selectedTool() === tool.id"
                  [class.field-editor__tool--dragging]="draggingToolId === tool.id"
                  [class.field-editor__tool--disabled]="isToolDisabled(tool)"
                  [attr.aria-disabled]="isToolDisabled(tool)"
                  [attr.draggable]="!isToolDisabled(tool)"
                  (click)="onToolClick(tool.id, $event)"
                  (keydown.enter)="onToolClick(tool.id, $event)"
                  (keydown.space)="onToolClick(tool.id, $event); $event.preventDefault()"
                  (dragstart)="onToolDragStart($event, tool.id)"
                  (dragend)="onToolDragEnd()">
                  <mat-icon>{{ tool.icon }}</mat-icon>
                  <span>{{ tool.label }}</span>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </aside>
  }

  <div class="field-editor__center">
    <!-- @if (selfSignMode) {
      <div class="field-editor__self-sign-bar" [class.field-editor__self-sign-bar--ready]="hasSelfSignActiveSignature">
        @if (hasSelfSignActiveSignature) {
          <img class="field-editor__self-sign-preview" [src]="selfSignActivePreview" alt="" />
          <div class="field-editor__self-sign-copy">
            <strong>{{ 'selfSignReadyTitle' | translate }}</strong>
            <span>{{ 'selfSignReadyHint' | translate }}</span>
          </div>
          <button mat-stroked-button type="button" class="field-editor__self-sign-change" (click)="changeSelfSignSignature()">
            {{ 'selfSignChange' | translate }}
          </button>
        } @else {
          <mat-icon class="field-editor__self-sign-icon">draw</mat-icon>
          <div class="field-editor__self-sign-copy">
            <strong>{{ 'selfSignPickTitle' | translate }}</strong>
            <span>{{ 'selfSignPickHint' | translate }}</span>
          </div>
          <button mat-flat-button type="button" class="field-editor__self-sign-choose" (click)="changeSelfSignSignature()">
            {{ 'selfSignChooseSignature' | translate }}
          </button>
        }
      </div>
    } -->
    <div class="field-editor__pdf-stage">
      <div
        class="pdf-container"
        [class.pdf-container--drag-over]="isPdfDragOver"
        (dragenter)="onPdfDragEnter($event)"
        (dragover)="onPdfDragOver($event)"
        (drop)="onPdfDrop($event)"
        (dragleave)="onPdfDragLeave($event)">
        <div class="pdf-container__viewport">
          <div class="field-editor__pdf-toolbar" (click)="$event.stopPropagation()">
            <div class="field-editor__toolbar-group">
              <button
                type="button"
                class="field-editor__toolbar-btn"
                [disabled]="!canGoToPreviousPage"
                aria-label="Previous page"
                (click)="goToPreviousPage()">
                <mat-icon>keyboard_arrow_up</mat-icon>
              </button>
              <span class="field-editor__toolbar-pages">{{ currentPageIndex }} / {{ totalPages.length || 1 }}</span>
              <button
                type="button"
                class="field-editor__toolbar-btn"
                [disabled]="!canGoToNextPage"
                aria-label="Next page"
                (click)="goToNextPage()">
                <mat-icon>keyboard_arrow_down</mat-icon>
              </button>
            </div>
            <span class="field-editor__toolbar-divider" aria-hidden="true"></span>
            <div class="field-editor__toolbar-group">
              <button
                type="button"
                class="field-editor__toolbar-btn"
                [disabled]="!canZoomOut"
                aria-label="Zoom out"
                (click)="zoomOut()">
                <mat-icon>zoom_out</mat-icon>
              </button>
              <span class="field-editor__toolbar-zoom">{{ pdfZoomPercent }}%</span>
              <button
                type="button"
                class="field-editor__toolbar-btn"
                [disabled]="!canZoomIn"
                aria-label="Zoom in"
                (click)="zoomIn()">
                <mat-icon>zoom_in</mat-icon>
              </button>
            </div>
          </div>

          <div
            class="pdf-container__scroll"
            #pdfContainer
            (click)="handlePdfClick($event)"
            (dragover)="onPdfDragOver($event)"
            (drop)="onPdfDrop($event)">
            <div
              class="pdf-container__inner"
              #pdfPagesHost
              (dragover)="onPdfDragOver($event)"
              (drop)="onPdfDrop($event)">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
